import { Animation, PageTransition } from 'ionic-angular';

export class ModalSlideTopLeaveTransition extends PageTransition {
  init() {
    super.init();
    const ele: HTMLElement = this.leavingView.pageRef().nativeElement;
    let backdrop = new Animation(this.plt, ele.querySelector('ion-backdrop'));
    let wrapperEle = <HTMLElement>ele.querySelector('.modal-wrapper');
    let wrapperEleRect = wrapperEle.getBoundingClientRect();
    let wrapper = new Animation(this.plt, wrapperEle);

    // height of the screen - top of the container tells us how much to scoot it down
    // so it's off-screen
    wrapper.fromTo('translateY', '0px', '0px');
    backdrop.fromTo('opacity', 0.4, 0.0);

    this
      .element(this.leavingView.pageRef())
      .easing('ease-out')
      .duration(0)
      .add(backdrop)
      .add(wrapper);
  }
}



// WEBPACK FOOTER //
// ./src/transitions/slide/slide-top-leave.transition.ts